import * as model from './models';

import createAxios from '@framework/http';
const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.KS_ENV !== 'prod' });

/** Item Shelf Controller  将已下架商品上架 */
export async function addItemUsingPOST(params: { param: model.IItemOpParam; shopId: string }) {
    const result = await axios.post<model.IMessageItemOpRetVO>(`/rest/op/vc/item/seller/shelf/add`, {
        ...params.param,
    });
    return result;
}

/** Item Shelf Controller  分页获取商品列表，支持根据商品ID、商品名称进行查询 */
export async function listItemUsingPOST(params: { param: model.IShelfPageParam; shopId: string }) {
    const result = await axios.post<model.IMessageShelfItemListVO>(`/rest/op/vc/item/seller/shelf/list`, {
        ...params.param,
    });
    return result;
}

/** Item Shelf Controller  查询商品各维度的数量 */
export async function itemNumUsingPOST(params: { param: model.IItemNumParam; shopId: string }) {
    const result = await axios.post<model.IMessageItemNumVO>(`/rest/op/vc/item/seller/shelf/num`, { ...params.param });
    return result;
}

/** Item Shelf Controller  将已上架商品下架 */
export async function removeItemUsingPOST(params: { param: model.IItemOpParam; shopId: string }) {
    const result = await axios.post<model.IMessageItemOpRetVO>(`/rest/op/vc/item/seller/shelf/remove`, {
        ...params.param,
    });
    return result;
}

/** Item Shelf Controller  修改Sku价格 */
export async function updateSkuPriceUsingPOST(params: { param: model.ISkuPriceUpdateParam; shopId: string }) {
    const result = await axios.post<model.IMessageSkuOpRetVO>(`/rest/op/vc/item/seller/shelf/sku/price`, {
        ...params.param,
    });
    return result;
}

/** Item Shelf Controller  修改Sku库存 */
export async function updateSkuStockUsingPOST(params: { param: model.ISkuStockUpdateParam; shopId: string }) {
    const result = await axios.post<model.IMessageSkuOpRetVO>(`/rest/op/vc/item/seller/shelf/sku/stock`, {
        ...params.param,
    });
    return result;
}

/** Item Shelf Controller  已下架商品删除 */
export async function deleteItemUsingPOST(params: { itemId: string; operationType: boolean }) {
    const { data } = await axios.post<model.ISelfDeleteVO>(`/rest/op/vc/item/seller/shelf/delete`, params);
    return data;
}
/** Item Shelf Controller  恢复已删除商品 */
export async function recoverItemUsingPOST(params: { itemId: string; operationType: boolean }) {
    const { data } = await axios.post<model.ISelfDeleteVO>(`/rest/op/vc/item/seller/shelf/recover`, params);
    return data;
}